(function ($) {
  $(function () {
    var $accordions = $(".js-accordion"),
      $firstAccordion = $accordions.first(),
      $accordionTitles = $(".js-accordion-title"),
      $accordionCopy = $(".js-accordion-copy");

    // currently not in use. logic preserved
    if ($accordions.data("data-open-first") === true) {
      /* Open the first section on load */
      $firstAccordion.find(".js-accordion-title").addClass("open");
      $firstAccordion.find(".js-accordion-copy").slideDown();
    }

    $accordionTitles.each(function ($index) {
      $($accordionTitles[$index]).on("click", function (e) {
        var $this = $(this);

        // if accordion is already open, just close the accordion
        if ($this.hasClass("open")) {
          //Close the current section
          $this.removeClass("open");
          $this.next($accordionCopy).slideUp();
        } else {
          // if clicking an accordion when another accordion is open...

          // Side up all sections that are open & remove their open class
          $accordionTitles.each(function ($index) {
            if ($($accordionTitles[$index]).hasClass("open")) {
              $($accordionTitles[$index]).removeClass("open");
              $($accordionTitles[$index]).next($accordionCopy).slideUp();
            }
          });

          // open new accordion
          $this.addClass("open");
          $this.next($accordionCopy).slideDown();
        }
      });
    });
  });
})(jQuery);
